import React from 'react'
import ReactDOM from 'react-dom'
import './bootstrap/bootstrap.css'
import './index.css'
import App from './components/App/App'
import registerServiceWorker from './registerServiceWorker'
import { HashRouter } from 'react-router-dom'

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js